// src/RimcInfo.js
import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faFileAlt, faRupeeSign, faUserGraduate, faRupee, faIndianRupee, faMoneyBill, faMoneyCheck } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from "./../../assets/schoolImage.png"
const RimcInfo = () => {
    const examDetails = [
        { subject: 'English', marks: '125 Marks' },
        { subject: 'Mathematics', marks: '200 Marks' },
        { subject: 'General Knowledge', marks: '75 Marks' },
        { subject: 'Viva-Voce Test', marks: '50 Marks' }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                        Rashtriya Indian Military College
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <div className="mb-4">
                    <img 
                        src={img} 
                        alt="Rashtriya Indian Military College" 
                        style={{
                            width: '100%',
                            height: '370px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
                        }}
                    />
                </div>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                            RIMC Entrance Exam
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Approximately 25 cadets are admitted every six months. Candidates should not be less than 11 1/2 years of age or must not have attained the age of 13 on 01 (Jan) or 01 (July) of the term they join in. Admissions are made to class VIII only. The candidate must be studying in class VII or have passed class VII from a recognised school at the time of joining.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Application forms are to be submitted to the respective State Governments. Candidates are selected on the basis of their performance in an all India Entrance Examination held twice a year.
                            </p>
                        </div>
                        
                        <div className="mb-0">
                            <h6 className="mb-3" style={{ color: '#1e3c72', fontWeight: '600' }}>Examination Pattern:</h6>
                            <div className="row justify-content-center">
                                {examDetails.map((exam, index) => (
                                    <div key={index} className="col-md-6 col-lg-3 mb-3">
                                        <div 
                                            className="p-3 text-center rounded"
                                            style={{
                                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                                color: 'white',
                                                minHeight: '80px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                boxShadow: '0 4px 15px rgba(30,60,114,0.2)',
                                                transition: 'all 0.3s'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(30,60,114,0.3)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(30,60,114,0.2)';
                                            }}
                                        >
                                            <FontAwesomeIcon 
                                                icon={faFileAlt} 
                                                style={{ fontSize: '1.5rem', marginBottom: '8px' }}
                                            />
                                            <h6 className="mb-1 fw-bold">{exam.subject}</h6>
                                            <small>{exam.marks}</small>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faMoneyCheck} className="me-2" />
                            RIMC Scholarship
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="text-center">
                            <div 
                                className="p-4 rounded mb-4"
                                style={{
                                    background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                    color: 'white',
                                    display: 'inline-block',
                                    boxShadow: '0 8px 25px rgba(22,160,133,0.2)'
                                }}
                            >
                                <FontAwesomeIcon 
                                    icon={faIndianRupee} 
                                    style={{ fontSize: '3rem', marginBottom: '15px' }}
                                />
                                <h4 className="mb-2 fw-bold">Rs. 50,000/-</h4>
                                <p className="mb-0">Per Annum</p>
                            </div>
                            
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Government of Haryana provides a scholarship for the cadets of Haryana domicile studying in RIMC, Dehradun. The scholarship amount is Rs. 50,000/- per annum.
                            </p>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};



export default RimcInfo;
